'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import Image from 'next/image';
import Link from 'next/link';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import { APPINSTALL_URL } from '@/app/cc/_consts/APPINSTALL_URL';
import { sendGA } from '@/app/cc/_util/sendGA';
import styles from './AppInstallModal.module.scss';
interface AppInstallModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
export default function AppInstallModal(t0) {
  const $ = _c(17);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = open => !open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.Overlay className={styles.overlay} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text as="span" category="title" variant="m3" color="var(--color-secondary-500)">이실장 App</Text>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dialog.Title asChild={true}><Text as="p" category="title" variant="m3" color="var(--color-gray-700)">{t3}에서 안심케어 중개사와<br />매물 정보를 확인해 보세요.</Text></Dialog.Title>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dialog.Description asChild={true}><div className="sr-only">이실장 App 다운로드 모달</div></Dialog.Description>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.QRCodeImage}><Image src={APPINSTALL_URL.ANDROID.qrCode} alt="Android QR Code" width={140} height={140} /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={styles.QRCodeContent}>{t6}<Link href={APPINSTALL_URL.DOWNLOAD_URL.android} target="_blank" rel="noopener noreferrer" className={styles.QRCodeButton} onClick={_temp}><Image src={APPINSTALL_URL.ANDROID.buttonImage} alt={"Android \uB2E4\uC6B4\uB85C\uB4DC"} width={162} height={48} /></Link></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={styles.QRCodeImage}><Image src={APPINSTALL_URL.IOS.qrCode} alt="iOS QR Code" width={140} height={140} /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.contentInner}>{t4}{t5}<div className={styles.QRCodeContainer}>{t7}<div className={styles.QRCodeContent}>{t8}<Link href={APPINSTALL_URL.DOWNLOAD_URL.ios} target="_blank" rel="noopener noreferrer" className={styles.QRCodeButton} onClick={_temp2}><Image src={APPINSTALL_URL.IOS.buttonImage} alt={"iOS \uB2E4\uC6B4\uB85C\uB4DC"} width={156} height={48} /></Link></div></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Text as="span" category="button" variant="sb2" color="var(--color-gray-0)">확인</Text>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== onClose) {
    t11 = <Dialog.Portal>{t2}<Dialog.Content className={styles.content}>{t9}<Dialog.Close asChild={true}><div className={styles.confirmButtonWrapper}><button type="button" className={styles.confirmButton} onClick={onClose}>{t10}</button></div></Dialog.Close></Dialog.Content></Dialog.Portal>;
    $[11] = onClose;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== isOpen || $[14] !== t1 || $[15] !== t11) {
    t12 = <Dialog.Root open={isOpen} onOpenChange={t1}>{t11}</Dialog.Root>;
    $[13] = isOpen;
    $[14] = t1;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}
function _temp2() {
  sendGA("appleDownClick");
}
function _temp() {
  sendGA("androidDownClick");
}